import { Box, Stack, styled } from '@mui/material';

interface GroupRowStackProps {
  isLast?: boolean;
}

export const DividerLineBox = styled(Box)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  width: '100%',
  marginInline: 0
}));

export const GroupRowStack = styled(Stack, {
  shouldForwardProp: prop => prop !== 'isLast'
})<GroupRowStackProps>(({ theme, isLast }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
  height: 56,
  paddingInline: theme.spacing(1.5),
  borderRadius: theme.shape.borderRadius,
  borderBottom: isLast ? 'none' : `1px solid ${theme.palette.divider}`,
  cursor: 'pointer',
  transition: 'background-color 0.2s ease',
  '&:hover': {
    backgroundColor: theme.palette.action.hover
  }
}));
